export default "__VITE_ASSET__C162nO_C__"